import { Snackbar } from '@mui/material';
import StatusBar from '../molecules/StatusBar';
import PageHeader from '../molecules/PageHeader';
import CreateNewHomeCat from '../molecules/CreateNewHomeCat';
import HomeCatList from '../molecules/HomeCatList/HomeCatList';

const HomeCatLayout = ({
  snackClose,
  snackOpen,
  snackMsg,
  homecats,
  snackBarType,
  deleteHomeCat,
  ...props
}) => {
  return (
    <div>
      <PageHeader testid='homecat-page-title'>
        Home Catechist Accounts
      </PageHeader>

      <div className='gap-3 md:grid md:grid-cols-5'>
        <div className='col-span-3'>
          <HomeCatList homecats={homecats} deleteHomeCat={deleteHomeCat} />
          <div className='order-1 my-4 text-center text-sm text-gray-500'>
            HomeCat accounts are administrator account with limited access to
            view students under Home Catechism only.
          </div>
        </div>

        <div className='col-span-2 my-4 rounded-md bg-primary-100 p-3 md:my-0'>
          <CreateNewHomeCat {...props} />
        </div>
      </div>

      <Snackbar
        open={snackOpen}
        autoHideDuration={6000}
        onClose={snackClose}
        id='snackbar'
      >
        <StatusBar type={snackBarType} closeHandler={snackClose}>
          {snackMsg}
        </StatusBar>
      </Snackbar>
    </div>
  );
};

export default HomeCatLayout;
